import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The RegionalAmountsTradedProvidersSize's component.
 */
const RegionalAmountsTradedProvidersSize = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image
        alt="Imagen ayuda"
        src="/assets/images/accordion-examples/Ejemplo-InfoRegional-MontosTransados-Proveedores.svg"
      />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>Selecciona el tipo de moneda para los datos, puede ser peso chileno o dólar estadounidense.</Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Corresponde al tamaño de empresa de los proveedores.</Item>
        <Item>Indicadores que representan el porcentaje de montos transados en relación al total regional.</Item>
        <Item>
          Monto total transado y número de órdenes de compra por cada tamaño de empresa de los proveedores de la región.
        </Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default RegionalAmountsTradedProvidersSize
